import i18next from 'i18next'
import type { RouteProps } from 'react-router'
import { ExpShellCopyTraining } from '@/pages/exp-shell-copy-training'
import { ExpVettingCopyTraining } from '@/pages/exp-vetting-copy-training'
import { ExperienceCriteriaVetting } from '@/pages/experience-criteria-vetting'
import { ExperienceMerchandisingVettingPage } from '@/pages/experience-merchandising-vetting-page'
import { ExperienceProPhotos } from '@/pages/experience-pro-photos'
import { ExperienceShell } from '@/pages/experience-shell'
import { ExperienceShellUpgrade } from '@/pages/experience-shell-upgrade'
import { ExperienceViewOnly } from '@/pages/experience-view-only'
import { GeometryCheck } from '@/pages/geometry-check'
import { HostReviewFullRejectionDetail } from '@/pages/host-review-full-rejection-detail'
import { HostReviewFullRejections } from '@/pages/host-review-full-rejections'
import { Login } from '@/pages/login'
import { LuxeSubmissionsCsvUploads } from '@/pages/luxe-submissions-csv-uploads'
import { LuxeSubmissionsFinalReview } from '@/pages/luxe-submissions-final-review'
import { LuxeSubmissionsIndex } from '@/pages/luxe-submissions-index'
import { LuxeSubmissionsInitialEvaluations } from '@/pages/luxe-submissions-initial-evaluations'
import { LuxeSubmissionsListing } from '@/pages/luxe-submissions-listing'
import { LuxeSubmissionsMpConversion } from '@/pages/luxe-submissions-mp-conversion'
import { LuxeSubmissionsQueueVisualVetting } from '@/pages/luxe-submissions-queue-visual-vetting'
import { LuxeSubmissionsQuoteGeneration } from '@/pages/luxe-submissions-quote-generation'
import { LuxeSubmissionsSubmission } from '@/pages/luxe-submissions-submission'
import { LuxeSubmissionsSubmissionListing } from '@/pages/luxe-submissions-submission-listing'
import { LuxeSubmissionsSubmissionOther } from '@/pages/luxe-submissions-submission-other'
import { LuxeSubmissionsTeamProductivity } from '@/pages/luxe-submissions-team-productivity'
import { MarqueeAttendeeDetail } from '@/pages/marquee-attendee-detail'
import { MarqueeEventAttendees } from '@/pages/marquee-event-attendees'
import { MarqueeEventCheckIn } from '@/pages/marquee-event-check-in'
import { MarqueeEventEdit } from '@/pages/marquee-event-edit'
import { MarqueeEventExport } from '@/pages/marquee-event-export'
import { MarqueeEventNew } from '@/pages/marquee-event-new'
import { MarqueeEventReport } from '@/pages/marquee-event-report'
import { MarqueeEvents } from '@/pages/marquee-events'
import { MarqueeHostLookupTable } from '@/pages/marquee-host-lookup-table'
import { MarqueeLocations } from '@/pages/marquee-locations'
import { MarqueeTeam } from '@/pages/marquee-team'
import { NotFound } from '@/pages/not-found'
import { PhotosetAiManualRetouchingStep } from '@/pages/photoset-ai-manual-retouching-step'
import { PhotosetAiManualRetouchingUploadStep } from '@/pages/photoset-ai-manual-retouching-upload-step'
import { PhotosetAiVettingCompletedStep } from '@/pages/photoset-ai-vetting-completed'
import { PhotosetAiVettingStep } from '@/pages/photoset-ai-vetting-step'
import { PhotosetAllocationStep } from '@/pages/photoset-allocation-step'
import { PhotosetCompletedSteps } from '@/pages/photoset-completed-steps'
import { PhotosetCurationStep } from '@/pages/photoset-curation-step'
import { PhotosetCurationStepV1 } from '@/pages/photoset-curation-step-v1'
import { PhotosetEditingQaCompletedStep } from '@/pages/photoset-editing-qa-completed-step'
import { PhotosetEditingQaFlagsStep } from '@/pages/photoset-editing-qa-flags-step'
import { PhotosetEditingQaSelectionStep } from '@/pages/photoset-editing-qa-selection-step'
import { PhotosetImagenAiStep } from '@/pages/photoset-imagen-ai-step'
import { PhotosetInitialQaStep } from '@/pages/photoset-initial-qa-step'
import { PhotosetInitialQaStepV1 } from '@/pages/photoset-initial-qa-step-v1'
import { PhotosetNeedsReviewStep } from '@/pages/photoset-needs-review-step'
import { PhotosetPublicShowcase } from '@/pages/photoset-public-showcase'
import { PhotosetRejected } from '@/pages/photoset-rejected'
import { PhotosetRetouchingQaCompletedStep } from '@/pages/photoset-retouching-qa-completed-step'
import { PhotosetRetouchingQaStep } from '@/pages/photoset-retouching-qa-step'
import { PhotosetRetouchingRevisionApprovedStep } from '@/pages/photoset-retouching-revision-approved-step'
import { PhotosetRetouchingRevisionStep } from '@/pages/photoset-retouching-revision-step'
import { PhotosetRetouchingRevisionUploadStep } from '@/pages/photoset-retouching-revision-upload-step'
import { PhotosetUnavailableQa } from '@/pages/photoset-unavailable-qa'
import { PhotosetUnavailable2La } from '@/pages/photoset-unavailable2-la'
import { PhotosetVettingQaStep } from '@/pages/photoset-vetting-qa-step'
import { Photoset2LaIndex } from '@/pages/photoset2-la-index'
import { ResetPassword } from '@/pages/reset-password'
import { Roadmap2026 } from '@/pages/roadmap-2026'
import { ServiceCopyTraining } from '@/pages/service-copy-training'
import { ServiceCriteriaVetting } from '@/pages/service-criteria-vetting'
import { ServiceMerchandisingVettingPage } from '@/pages/service-merchandising-vetting-page'
import { ServiceProPhotos } from '@/pages/service-pro-photos'
import { SetPassword } from '@/pages/set-password'
import { SsoRedirect } from '@/pages/sso-redirect'
import { SubGeoTerritoryBuilder } from '@/pages/sub-geo-territory-builder'
import { Welcome } from '@/pages/welcome'
import { LuxeSubmissionsFinalReviewDetails } from './pages/luxe-submissions-final-review-details'
import { LuxeSubmissionsListingScoreForm } from './pages/luxe-submissions-listing-score-form'
import { LuxeSubmissionsMMDataOverview } from './pages/luxe-submissions-mm-data-overview'
import { LuxeSubmissionsMMOverviewParkingLotDetails } from './pages/luxe-submissions-mm-overview-parking-lot-details'
import { LuxeSubmissionsMMOverviewSubmissionDetails } from './pages/luxe-submissions-mm-overview-submission-details'
import { LuxeSubmissionsMMParkingLot } from './pages/luxe-submissions-mm-parking-lot'
import { LuxeSubmissionsMMSubmissions } from './pages/luxe-submissions-mm-submissions'

export const routes = {
	LOGIN: {
		path: '/login',
		element: <Login />,
		handle: {
			redirectTo: '/'
		}
	},
	SUBGEO_LOGIN: {
		path: '/subgeo/login',
		element: <Login />,
		handle: {
			redirectTo: '/subgeo'
		}
	},
	LUXE_SUBMISSIONS_LOGIN: {
		path: 'login',
		element: <Login />,
		handle: {
			fullPath: '/luxe-submissions/login',
			redirectTo: '/luxe-submissions'
		}
	},
	LUXE_SUBMISSIONS_INDEX: {
		path: '',
		index: true,
		element: <LuxeSubmissionsIndex />,
		handle: {
			fullPath: '/luxe-submissions'
		}
	},
	LUXE_SUBMISSIONS_INITIAL_EVALUATIONS: {
		path: 'initial-evaluations',
		element: <LuxeSubmissionsInitialEvaluations />,
		handle: {
			fullPath: '/luxe-submissions/queue/initial-evaluations'
		}
	},
	LUXE_SUBMISSIONS_SUBMISSION: {
		path: '',
		element: <LuxeSubmissionsSubmission />,
		handle: {
			fullPath: '/luxe-submissions/submission'
		}
	},
	LUXE_SUBMISSIONS_SUBMISSION_LISTING: {
		path: 'listing',
		element: <LuxeSubmissionsSubmissionListing />,
		handle: {
			fullPath: '/luxe-submissions/submission/listing'
		}
	},
	LUXE_SUBMISSIONS_SUBMISSION_OTHER: {
		path: 'other',
		element: <LuxeSubmissionsSubmissionOther />,
		handle: {
			fullPath: '/luxe-submissions/submission/other'
		}
	},
	LUXE_SUBMISSIONS_QUEUE_VISUAL_VETTING: {
		path: 'visual-vetting',
		element: <LuxeSubmissionsQueueVisualVetting />,
		handle: {
			fullPath: '/luxe-submissions/queue/visual-vetting'
		}
	},
	LUXE_SUBMISSIONS_FINAL_REVIEW: {
		path: 'final-review',
		element: <LuxeSubmissionsFinalReview />,
		handle: {
			fullPath: '/luxe-submissions/queue/final-review'
		}
	},
	LUXE_SUBMISSIONS_QUOTE_GENERATION: {
		path: 'offer-generation',
		element: <LuxeSubmissionsQuoteGeneration />,
		handle: {
			fullPath: '/luxe-submissions/queue/offer-generation'
		}
	},
	LUXE_SUBMISSIONS_LISTING: {
		path: 'listings/:id',
		element: <LuxeSubmissionsListing />,
		handle: {
			fullPath: '/luxe-submissions/listings/:id'
		}
	},
	LUXE_SUBMISSIONS_LISTING_SCORE_FORM: {
		path: 'listings/:id/score-form',
		element: <LuxeSubmissionsListingScoreForm />,
		handle: {
			fullPath: '/luxe-submissions/listings/:id/score-form'
		}
	},
	LUXE_SUBMISSIONS_LISTING_FINAL_REVIEW: {
		path: 'listings/:id/final-review',
		element: <LuxeSubmissionsFinalReviewDetails />,
		handle: {
			fullPath: '/luxe-submissions/listings/:id/final-review'
		}
	},
	LUXE_SUBMISSIONS_MM_SUBMISSIONS: {
		path: 'submissions',
		element: <LuxeSubmissionsMMSubmissions />,
		handle: {
			fullPath: '/luxe-submissions/mm-overview/submissions'
		}
	},
	LUXE_SUBMISSIONS_MM_PARKING_LOT: {
		path: 'parking-lot',
		element: <LuxeSubmissionsMMParkingLot />,
		handle: {
			fullPath: '/luxe-submissions/mm-overview/parking-lot'
		}
	},
	LUXE_SUBMISSIONS_MM_DATA_OVERVIEW: {
		path: 'data-overview',
		element: <LuxeSubmissionsMMDataOverview />,
		handle: {
			fullPath: '/luxe-submissions/mm-overview/data-overview'
		}
	},
	LUXE_SUBMISSIONS_MM_SUBMISSION_DETAILS: {
		path: 'submissions/:id',
		element: <LuxeSubmissionsMMOverviewSubmissionDetails />,
		handle: {
			fullPath: '/luxe-submissions/mm-overview/submissions/:id'
		}
	},
	LUXE_SUBMISSIONS_MM_PARKING_LOT_DETAILS: {
		path: 'parking-lot/:id',
		element: <LuxeSubmissionsMMOverviewParkingLotDetails />,
		handle: {
			fullPath: '/luxe-submissions/mm-overview/parking-lot/:id'
		}
	},
	LUXE_SUBMISSIONS_CSV_UPLOADS: {
		path: '',
		index: true,
		element: <LuxeSubmissionsCsvUploads />,
		handle: {
			fullPath: '/luxe-submissions/csv-uploads'
		}
	},
	LUXE_SUBMISSIONS_TEAM_PRODUCTIVITY: {
		path: 'team-productivity',
		element: <LuxeSubmissionsTeamProductivity />,
		handle: {
			fullPath: '/luxe-submissions/team-productivity'
		}
	},
	LUXE_SUBMISSIONS_MP_CONVERSION: {
		path: 'mp-conversion',
		element: <LuxeSubmissionsMpConversion />,
		handle: {
			fullPath: '/luxe-submissions/mp-conversion'
		}
	},
	MARQUEE_LOGIN: {
		path: 'login',
		element: <Login brand='Marquee' />,
		handle: {
			fullPath: '/marquee/login',
			redirectTo: '/marquee'
		}
	},
	MARQUEE_EVENTS: {
		path: '',
		index: true,
		element: <MarqueeEvents />,
		handle: {
			fullPath: '/marquee/events'
		}
	},
	MARQUEE_EVENT_NEW: {
		path: 'new',
		element: <MarqueeEventNew />,
		handle: {
			fullPath: '/marquee/events/new',
			breadcrumb: 'marquee:breadcrumb_create_new'
		}
	},
	MARQUEE_EVENT_DETAIL: {
		path: ':id',
		handle: {
			fullPath: '/marquee/events/:id'
		}
	},
	MARQUEE_EVENT_EDIT: {
		path: ':id/edit',
		element: <MarqueeEventEdit />,
		handle: {
			fullPath: '/marquee/events/:id/edit',
			breadcrumb: 'marquee:breadcrumb_edit'
		}
	},
	MARQUEE_EVENT_ATTENDEES: {
		path: 'attendees',
		element: <MarqueeEventAttendees />,
		handle: {
			fullPath: '/marquee/events/:id/attendees'
		}
	},
	MARQUEE_EVENT_ATTENDEE_DETAIL: {
		path: 'attendees/:attendeeId',
		element: <MarqueeAttendeeDetail />,
		handle: {
			fullPath: '/marquee/events/:id/attendees/:attendeeId'
		}
	},
	MARQUEE_EVENT_CHECK_IN: {
		path: 'check-in',
		element: <MarqueeEventCheckIn />,
		handle: {
			fullPath: '/marquee/events/:id/check-in'
		}
	},
	MARQUEE_EVENT_EXPORT: {
		path: 'export',
		element: <MarqueeEventExport />,
		handle: {
			fullPath: '/marquee/events/:id/export'
		}
	},
	MARQUEE_EVENT_REPORT: {
		path: 'report',
		element: <MarqueeEventReport />,
		handle: {
			fullPath: '/marquee/events/:id/report'
		}
	},
	MARQUEE_HOST_LOOKUP_TABLE: {
		path: 'host-lookup-table',
		element: <MarqueeHostLookupTable />,
		handle: {
			fullPath: '/marquee/host-lookup-table',
			breadcrumb: 'marquee:breadcrumb_host_lookup_table'
		}
	},
	MARQUEE_TEAM: {
		path: 'team',
		element: <MarqueeTeam />,
		handle: {
			fullPath: '/marquee/team',
			breadcrumb: 'marquee:breadcrumb_team'
		}
	},
	MARQUEE_LOCATIONS: {
		path: 'locations',
		element: <MarqueeLocations />,
		handle: {
			fullPath: '/marquee/locations',
			breadcrumb: 'marquee:breadcrumb_locations'
		}
	},
	RESET_PASSWORD: {
		path: '/reset-password',
		element: <ResetPassword />
	},
	SET_PASSWORD: {
		path: '/set-password/:token',
		element: <SetPassword />
	},
	SSO_REDIRECT: {
		path: '/redirect',
		element: <SsoRedirect />
	},
	WELCOME: {
		path: '/',
		element: <Welcome />
	},
	PHOTOSET_REJECTED: {
		path: '/photoset/:id/editing/rejected',
		element: <PhotosetRejected />,
		handle: {
			path: '/photoset/:id/editing/rejected',
			paramName: 'id',
			name: ''
		}
	},
	// Editing Routes
	PHOTOSET_INITIAL_QA: {
		path: '/photoset/:id/editing/initial-qa',
		element: <PhotosetInitialQaStep />,
		handle: {
			path: '/photoset/:id/editing/initial-qa',
			paramName: 'id',
			name: ''
		}
	},
	PHOTOSET_ALLOCATION: {
		path: '/photoset/:id/editing/allocation',
		element: <PhotosetAllocationStep />,
		handle: {
			path: '/photoset/:id/editing/allocation',
			paramName: 'id',
			name: ''
		}
	},
	PHOTOSET_CURATION: {
		path: '/photoset/:id/editing/curation',
		element: <PhotosetCurationStep />,
		handle: {
			path: '/photoset/:id/editing/curation',
			paramName: 'id',
			name: ''
		}
	},
	// Check this path ->
	PHOTOSET_CURATION_COMPLETED: {
		path: '/photoset/:id/editing/curation-completed',
		element: <PhotosetCompletedSteps />,
		handle: {
			path: '/photoset/:id/editing/curation-completed',
			paramName: 'id',
			name: ''
		}
	},
	// <- Check this path
	PHOTOSET_AI_VETTING: {
		path: '/photoset/:id/editing/ai-vetting',
		element: <PhotosetAiVettingStep />,
		handle: {
			path: '/photoset/:id/editing/ai-vetting',
			paramName: 'id',
			name: ''
		}
	},
	PHOTOSET_AI_VETTING_COMPLETED: {
		path: '/photoset/:id/editing/ai-vetting-completed',
		element: <PhotosetAiVettingCompletedStep />,
		handle: {
			path: '/photoset/:id/editing/ai-vetting-completed',
			paramName: 'id',
			name: ''
		}
	},
	PHOTOSET_AI_MANUAL_RETOUCHING_UPLOAD: {
		path: '/photoset/:id/editing/ai-manual-retouching-upload',
		element: <PhotosetAiManualRetouchingUploadStep />,
		handle: {
			path: '/photoset/:id/editing/ai-manual-retouching-upload',
			paramName: 'id',
			name: ''
		}
	},
	PHOTOSET_AI_MANUAL_RETOUCHING: {
		path: '/photoset/:id/editing/ai-manual-retouching',
		element: <PhotosetAiManualRetouchingStep />,
		handle: {
			path: '/photoset/:id/editing/ai-manual-retouching',
			paramName: 'id',
			name: ''
		}
	},
	PHOTOSET_NEEDS_REVIEW: {
		path: '/photoset/:id/editing/needs-review',
		element: <PhotosetNeedsReviewStep />,
		handle: {
			path: '/photoset/:id/editing/needs-review',
			paramName: 'id',
			name: ''
		}
	},
	PHOTOSET_RETOUCHING_REVISION_UPLOAD: {
		path: '/photoset/:id/editing/retouching-revision-upload',
		element: <PhotosetRetouchingRevisionUploadStep />,
		handle: {
			path: '/photoset/:id/editing/retouching-revision-upload',
			paramName: 'id',
			name: ''
		}
	},
	PHOTOSET_RETOUCHING_REVISION: {
		path: '/photoset/:id/editing/retouching-revision',
		element: <PhotosetRetouchingRevisionStep />,
		handle: {
			path: '/photoset/:id/editing/retouching-revision',
			paramName: 'id',
			name: ''
		}
	},
	PHOTOSET_RETOUCHING_REVISION_APPROVED: {
		path: '/photoset/:id/editing/retouching-revision-approved',
		element: <PhotosetRetouchingRevisionApprovedStep />,
		handle: {
			path: '/photoset/:id/editing/retouching-revision-approved',
			paramName: 'id',
			name: ''
		}
	},
	// QA Routes
	PHOTOSET_EDITING_QA_SELECTION: {
		path: '/photoset/:id/qa/editing-qa-selection',
		element: <PhotosetEditingQaSelectionStep />,
		handle: {
			path: '/photoset/:id/qa/editing-qa-selection',
			paramName: 'id',
			name: ''
		}
	},
	PHOTOSET_EDITING_QA_FLAGS: {
		path: '/photoset/:id/qa/editing-qa-flags',
		element: <PhotosetEditingQaFlagsStep />,
		handle: {
			path: '/photoset/:id/qa/editing-qa-flags',
			paramName: 'id',
			name: ''
		}
	},
	PHOTOSET_EDITING_QA_COMPLETED: {
		path: '/photoset/:id/qa/editing-qa-completed',
		element: <PhotosetEditingQaCompletedStep />,
		handle: {
			path: '/photoset/:id/qa/editing-qa-completed',
			paramName: 'id',
			name: ''
		}
	},
	PHOTOSET_VETTING_QA: {
		path: '/photoset/:id/qa/vetting-qa',
		element: <PhotosetVettingQaStep />,
		handle: {
			path: '/photoset/:id/qa/vetting-qa',
			paramName: 'id',
			name: ''
		}
	},
	PHOTOSET_RETOUCHING_QA: {
		path: '/photoset/:id/qa/retouching-qa',
		element: <PhotosetRetouchingQaStep />,
		handle: {
			path: '/photoset/:id/qa/retouching-qa',
			paramName: 'id',
			name: ''
		}
	},
	PHOTOSET_RETOUCHING_QA_COMPLETED: {
		path: '/photoset/:id/qa/retouching-qa-completed',
		element: <PhotosetRetouchingQaCompletedStep />,
		handle: {
			path: '/photoset/:id/qa/retouching-qa-completed',
			paramName: 'id',
			name: ''
		}
	},
	PHOTOSET_UNAVAILABLE_QA: {
		path: '/photoset/:id/qa/unavailable-qa',
		element: <PhotosetUnavailableQa />,
		handle: {
			path: '/photoset/:id/qa/unavailable-qa',
			paramName: 'id',
			name: ''
		}
	},
	// 2LA Routes
	PHOTOSET_2LA_INDEX: {
		path: '/photoset/:id/2la',
		element: <Photoset2LaIndex />,
		index: true,
		handle: {
			path: '/photoset/:id/2la',
			paramName: 'id',
			name: ''
		}
	},
	PHOTOSET_2LA_EDITING_QA_SELECTION: {
		path: '/photoset/:id/2la/editing-qa-selection',
		element: <PhotosetEditingQaSelectionStep />,
		handle: {
			path: '/photoset/:id/2la/editing-qa-selection',
			paramName: 'id',
			name: ''
		}
	},
	PHOTOSET_2LA_EDITING_QA_FLAGS: {
		path: '/photoset/:id/2la/editing-qa-flags',
		element: <PhotosetEditingQaFlagsStep />,
		handle: {
			path: '/photoset/:id/2la/editing-qa-flags',
			paramName: 'id',
			name: ''
		}
	},
	PHOTOSET_2LA_VETTING_QA: {
		path: '/photoset/:id/2la/vetting-qa',
		element: <PhotosetVettingQaStep />,
		handle: {
			path: '/photoset/:id/2la/vetting-qa',
			paramName: 'id',
			name: ''
		}
	},
	PHOTOSET_2LA_RETOUCHING_QA: {
		path: '/photoset/:id/2la/retouching-qa',
		element: <PhotosetRetouchingQaStep />,
		handle: {
			path: '/photoset/:id/2la/retouching-qa',
			paramName: 'id',
			name: ''
		}
	},
	PHOTOSET_UNAVAILABLE_2LA: {
		path: '/photoset/:id/2la/unavailable-2la',
		element: <PhotosetUnavailable2La />,
		handle: {
			path: '/photoset/:id/2la/unavailable-2la',
			paramName: 'id',
			name: ''
		}
	},
	//todo: remove after go live
	PHOTOSET_CURATION_STEP_V1: {
		path: '/photoset/:id/curation-v1',
		element: <PhotosetCurationStepV1 />,
		handle: {
			path: '/photoset/:id/curation-v1',
			paramName: 'id',
			name: ''
		}
	},
	PHOTOSET_IMAGEN_AI_STEP_V1: {
		path: '/photoset/:id/imagen-ai-v1',
		element: <PhotosetImagenAiStep />,
		handle: {
			path: '/photoset/:id/imagen-ai-v1',
			paramName: 'id',
			name: ''
		}
	},
	PHOTOSET_PUBLIC_SHOWCASE: {
		path: '/photoset/:id/show',
		element: <PhotosetPublicShowcase />,
		handle: {
			path: '/photoset/:id/show',
			paramName: 'id',
			name: ''
		}
	},
	PHOTOSET_INITIAL_QA_V1: {
		path: '/photoset/:id/initial-qa-v1',
		element: <PhotosetInitialQaStepV1 />,
		handle: {
			path: '/photoset/:id/initial-qa-v1',
			paramName: 'id',
			name: ''
		}
	},
	//Copy preparation AI tool
	EXP_AI_COPY_PREP_SHELL_TRAINING: {
		path: '/experience/ai-copy-prep/shell-training',
		element: <ExpShellCopyTraining />
	},
	EXP_AI_COPY_PREP_VETTING_TRAINING: {
		path: '/experience/ai-copy-prep/vetting-training',
		element: <ExpVettingCopyTraining />
	},
	SERVICE_COPY_TRAINING: {
		path: '/service/ai-copy-prep/training',
		element: <ServiceCopyTraining />
	},
	EXPERIENCES_SHELL: {
		path: '/experiences/:id/shell',
		element: <ExperienceShell />
	},
	EXPERIENCES_SHELL_UPGRADE: {
		path: '/experiences/:id/shell-upgrade',
		element: <ExperienceShellUpgrade />
	},
	// Service Vetting Routes
	SERVICE_VETTING_MERCHANDISING: {
		path: '/service-vetting/:id/merchandising',
		element: <ServiceMerchandisingVettingPage />
	},
	SERVICE_VETTING_CRITERIA: {
		path: '/service-vetting/:id/criteria',
		element: <ServiceCriteriaVetting />
	},
	EXPERIENCE_VETTING_MERCHANDISING: {
		path: '/experiences-vetting/:id/merchandising',
		element: <ExperienceMerchandisingVettingPage />
	},
	EXPERIENCE_VETTING_CRITERIA: {
		path: '/experiences-vetting/:id/criteria',
		element: <ExperienceCriteriaVetting />
	},
	EXPERIENCES_IMG_REORDERING: {
		path: '/experiences/:id/img-grid-reordering',
		element: <ExperienceProPhotos />
	},
	SERVICE_IMG_REORDERING: {
		path: '/services/:id/img-grid-reordering',
		element: <ServiceProPhotos />
	},
	EXPERIENCE_VIEW_ONLY: {
		path: '/experiences/:id',
		element: <ExperienceViewOnly />
	},
	// SubGeo Territory Builder Route
	SUBGEO_TERRITORY_BUILDER: {
		path: '/subgeo',
		element: <SubGeoTerritoryBuilder />
	},
	// SubGeo Geometry Check Route
	GEOMETRY_CHECK: {
		path: '/subgeo/geometry-check',
		element: <GeometryCheck />
	},
	// Roadmaps
	ROADMAP_2026: {
		path: '/roadmaps/2026',
		element: <Roadmap2026 />,
		handle: {
			fullPath: '/roadmaps/2026'
		}
	},
	// Host review - the Pro Photo team's read-only view of shoots where the host
	// removed every photo. No mutating affordance exists here by contract.
	HOST_REVIEW_FULL_REJECTIONS: {
		path: '/host-review/full-rejections',
		element: <HostReviewFullRejections />,
		handle: {
			fullPath: '/host-review/full-rejections'
		}
	},
	HOST_REVIEW_FULL_REJECTION_DETAIL: {
		path: '/host-review/full-rejections/:reviewId',
		element: <HostReviewFullRejectionDetail />,
		handle: {
			fullPath: '/host-review/full-rejections/:reviewId'
		}
	},
	NOT_FOUND: {
		path: '*',
		element: <NotFound />
	}
} as const satisfies Record<string, RouteProps>

//Utility routes
export const ServiceVettingSteps = [
	{
		label: i18next.t('vetting:criteria.commons.criteria'),
		path: routes.SERVICE_VETTING_CRITERIA.path
	},
	{
		label: i18next.t('vetting:merch.commons.merch'),
		path: routes.SERVICE_VETTING_MERCHANDISING.path
	}
] as const

export const ExperienceVettingSteps = [
	{
		label: i18next.t('vetting:criteria.commons.criteria'),
		path: routes.EXPERIENCE_VETTING_CRITERIA.path
	},
	{
		label: i18next.t('vetting:merch.commons.merch'),
		path: routes.EXPERIENCE_VETTING_MERCHANDISING.path
	}
] as const
